export const EXPERT_LISTINGS_SOURCE = 'expert_listings_page';

export const CARD_VARIANT = {
    DEFAULT: 'default',
    VISUAL: 'visual',
};
